"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadToMSBucket = void 0;
const axios_1 = require("axios");
const config_1 = require("./config");
const uploadToMSBucket = async (apiToken, file, ccdn = false) => {
    const signResponse = await axios_1.default.post(config_1.default.MS_BUCKET_SIGN_API, {
        fileName: file.name,
        contentType: file.type,
        ccdn,
    }, {
        headers: {
            apikey: apiToken,
        },
    });
    const presignedPostUrl = JSON.parse(signResponse.data.message);
    const formData = new FormData();
    // formData.append("Content-Type", file.type);
    Object.entries(presignedPostUrl.fields).forEach(([k, v]) => {
        formData.append(k, v);
    });
    formData.append("file", file); // The file has be the last element
    const response = await axios_1.default.post(presignedPostUrl.url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return `${presignedPostUrl.url}/${presignedPostUrl.fields.key}`;
};
exports.uploadToMSBucket = uploadToMSBucket;
